import { render, staticRenderFns } from "./SerpResultsList.vue?vue&type=template&id=3acae409&scoped=true"
import script from "./SerpResultsList.vue?vue&type=script&lang=js"
export * from "./SerpResultsList.vue?vue&type=script&lang=js"
import style0 from "./SerpResultsList.vue?vue&type=style&index=0&id=3acae409&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acae409",
  null
  
)

export default component.exports